import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="sw-app">
      <Header />
      <main id="main-content" className="sw-section" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
        <div className="sw-container">
          <h1 className="gradient-text" style={{ fontSize: '6rem', marginBottom: '1rem' }}>404</h1>
          <h2 style={{ marginBottom: '2rem' }}>Page Not Found</h2>
          <p className="text-soft" style={{ marginBottom: '3rem', maxWidth: '500px', marginInline: 'auto' }}>
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          <button className="sw-btn sw-btn-primary" onClick={() => navigate('/')}>
            Back to Home
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
